import styles from './AddShoppingListToCart.module.scss'
import { useAddShoppingListToCartMutation, useGetShoppingListQuery } from '@/api/shoppingList'
import Button from '@/components/buttons/Button/Button'
import LoadingOverlay from '@/components/common/LoadingOverlay/LoadingOverlay'
import Modal from '@/components/common/Modal/Modal'
import Raw from '@/components/common/Raw/Raw'
import { useSnackbar } from '@/utils/hooks/useSnackbar'
import React from 'react'
import { useTranslation } from 'next-i18next'

type Props = {
  onClose: () => void
  shoppingListId: string
}

const AddShoppingListToCart = ({ onClose, shoppingListId }: Props) => {
  const { t } = useTranslation(['common', 'cart'])
  const { data, isFetching } = useGetShoppingListQuery(shoppingListId)
  const [addToCart, { isLoading }] = useAddShoppingListToCartMutation()
  const { showSnackbar } = useSnackbar()

  const onAddToCart = async () => {
    await addToCart({ linkId: shoppingListId })
    showSnackbar(t('cart:articlesAddedToCart'))
    onClose()
  }

  return (
    <div>
      <Modal
        onClose={onClose}
        title={t('cart:sharedShoppingCart')}
        clickOutsideToClose={true}
      >
        <div>
          {(isFetching || isLoading) && <LoadingOverlay />}
          {(!isFetching && !data) && (
            <div>
              <p>{t('cart:sharedListNotFound')}</p>
              <div className='flex center margin-top-1 gap2'>
                <Button
                  onClick={onClose}
                  label={t('common:close')}
                  rounded={true}
                  dark={true}
                />
              </div>
            </div>
          )}
          {(!isFetching && data) && (
            <div>
              <Raw
                className={styles.text}
                content={t('cart:addSharedListToCart', { name: data.name, articleCount: data.articleCount })}
              />
              <div className='flex center margin-top-1 gap2'>
                <Button
                  onClick={onClose}
                  label={t('common:cancel')}
                  rounded={true}
                  dark={true}
                />
                <Button
                  onClick={onAddToCart}
                  label={t('common:add')}
                  rounded={true}
                />
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
  )
}

export default AddShoppingListToCart
